export const LogoMark = ({ size = 44, className = "" }) => (
  <img
    src="/logo.png"
    alt="Harshi's Kitchen logo"
    width={size}
    height={size}
    className={`rounded-full ${className}`}
    data-testid="logo-mark"
  />
);

export const Logo = () => (
  <div className="flex items-center" data-testid="nav-logo">
    <img
      src="/logo.png"
      alt="Harshi's Kitchen — Taste, Tradition and Celebration with Love"
      className="h-12 w-12 sm:h-14 sm:w-14 rounded-full shadow-[0_4px_14px_-4px_rgba(61,35,20,0.35)]"
    />
  </div>
);
